"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrderServiceContext = exports.OrderServiceContext = void 0;
var react_1 = require("react");
;
exports.OrderServiceContext = (0, react_1.createContext)({});
function useOrderServiceContext() {
    var context = (0, react_1.useContext)(exports.OrderServiceContext);
    if (!context) {
        throw new Error("Calculator compound components should be used only with Card");
    }
    return context;
}
exports.useOrderServiceContext = useOrderServiceContext;
